import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  transactions: [],
  totalCount: 0,
};

const TransactionReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_ALL_TRANSACTION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Transactions fetch successfully",
        transactions: action.payload.data,
        totalCount: action.payload.total_count,
      };
    case TYPE.GET_ALL_TRANSACTION_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching transactions",
        transactions: [],
      };
    case TYPE.CLEAR_OFFLINE_GOLD_PURCHASE:
      return {
        ...state,
        loading: false,
        error: false,
        message: "",
        transactions: [],
      };
    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default TransactionReportReducer;
